




















// @ is an alias to /src
import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import UserMenu from '@/views/Drawers/views/UserMenu.vue';
import {notificationsService} from "@/services/services";
import {pushSubscriptionUrl, subscriptionVapidKey} from "@/services/endpoints";
import {ANALYTIC_CLICKS} from "@/services/Analytics";

const userDataModule = namespace("userData");

@Component({
  name: 'HomeHeader',
  components: {
  },
})
export default class HomeHeader extends Vue {
  @userDataModule.Getter('getEmail')
  private userEmail!: string;

  @userDataModule.Getter('getOfficePhoneNumberLink')
  private getOfficePhoneNumberLink!: string;

  @Prop({ default: false })
  private showWarning!: boolean;

  private notificationsEnabled: boolean = false;

  private openMenu() {
    this.$uiBus.emit("drawer:show", UserMenu);
  }

  private created() {
    notificationsService.setPublicVapidKey(subscriptionVapidKey());
    notificationsService.setSubscriptionEndpoint(pushSubscriptionUrl());
    notificationsService.setUserId(this.userEmail);
    (async () => {
      this.notificationsEnabled = await notificationsService.init();
    })();

  }

  private showOnboarding() {
    ANALYTIC_CLICKS.onboarding(this.$gtag);
    this.$uiBus.emit("how-it-works:show");
  }
}
